import SettingsMigration from "./SettingsMigration";

export const setFalseTransform = (
    settings: any,
    originalSetting: any,
    destinationSetting: any
) => {
    console.log('Transform function called');

    try {
        const uploadSetting = settings?.Scanner?.Upload;
        if (uploadSetting?.value === 'When saving') {
            console.log("Upload setting is 'when saving'; skipping transform and returning original values.");
            return {
                originalNewSetting: { ...originalSetting },
                destinationNewSetting: { ...destinationSetting }
            };
        }
    } catch (e) {
        console.warn('Could not evaluate Upload setting prior to transform', e);
    }

    console.log('Original oldValue:', originalSetting);
    const modifiedOldValue = { ...originalSetting };
    const modifiedNewValue = { ...destinationSetting };

    modifiedOldValue.value = false;
    modifiedNewValue.value = originalSetting.value;
    console.log('Modified oldValue:', modifiedOldValue);

    return {
        originalNewSetting: modifiedOldValue,
        destinationNewSetting: modifiedNewValue
    };
};

export const migrations = [
    new SettingsMigration(
        "Scanner/ClearCustomFields",
        "Scanner/CustomFieldClearingBehavior",
        "clearCustomFieldsToCustomFieldClearingBehavior",
        undefined,
        "/Settings/User/Scanner/ClearCustomFields"
    ),
    new SettingsMigration(
        "Scanner/AutoSaveEnabled",
        "Scanner/CombineRemoteUploadButtonEnabled",
        "autoSaveToCombineRemoteUploadButtonEnabled",
        setFalseTransform
    ),
    new SettingsMigration(
        "Scanner/AutoExportEnabled",
        "Scanner/CombineRemoteExportButtonEnabled",
        "autoExportToCombineRemoteExportButtonEnabled",
        setFalseTransform
    ),
];